import PropTypes from 'prop-types';
import createReactContext from 'create-react-context';
import CollaborationCommentShape from '../Previewer/PropsShape/CollaborationCommentShape';

if (typeof window !== 'undefined') {
    window.global = window;
}

export default createReactContext({
    onMediaLoad: () => null,
    onPlay: () => null,
    onMarkerClick: () => null,
    markers: [],
    markersTemplate: () => null,
    onError: () => null,
    setEmbeddedElementRef: () => null
});

export const contextPropType = PropTypes.shape({
    onMediaLoad: PropTypes.func,
    onPlay: PropTypes.func,
    onMarkerClick: PropTypes.func,
    markers: PropTypes.arrayOf(CollaborationCommentShape),
    markersTemplate: PropTypes.func,
    onError: PropTypes.func
}).isRequired;
